import { toastr } from 'react-redux-toastr';
import errorMessage from '../errorMessages/errorMessage_en';

const showToaster = async ({ messageId, toasterType, requestMessage, language }) => {

    let message, lang, title;
    lang = language ? language : "en";
    if (lang == "en") {
        
        title = await errorMessage(toasterType);
        if (requestMessage) {
            message = requestMessage;
        } else if (messageId) {
            message = await errorMessage(messageId);
        } else {
            message = '';
        }
    }
    console.log("title", title);
    console.log("message", message);
    return toastr[toasterType](title, message)
}
export default showToaster;




